<template>
  <div class="app-container">
    <list ref="list" :can-price="canPrice">
      <template slot="toolbar-right" v-if="canWrite">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="primary" @click="onGenerate" v-if="IsSelfPicking">生成耗料单</el-button>
        <!-- <el-button type="primary" @click="create2" icon="el-icon-plus">添加注塑入库单</el-button> -->
        <el-dropdown style="margin-left: 10px;" @command="handleCommand">
          <el-button type="primary">添加注塑入库单<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="0">按胶件入库</el-dropdown-item>
            <el-dropdown-item :command="1">按模入库</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button v-if="canWrite && row.Status !== 2" @click="edit(row)" type="text">编辑</el-button>
            <el-button v-if="canReview && row.Status == 2" type="text" @click="edit(row)">查看</el-button>
                <el-button type="text" @click="onPrint(row)">打印</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/productionshipping/list'


export default {
  name: "productionshipping",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/stock/stInDoc").default,
      optionApi: require("@/api/sy/option").default,
      IsSelfPicking:false
    }
  },
  mounted() {
    this.optionApi.getInitialSetting().then((res) => {
      if (res.Code === 0) {
        this.IsSelfPicking = res.Data.IsSelfPicking;
      }
    });
  },
  computed: {
    canWrite() {
      return this.$permission.canWrite();
    },
    canPrice() {
      return this.$permission.canPrice();
    },
    canReview() {
      return this.$permission.canReview();
    },
  },
  methods: {
    edit(row) {
      
      let id = row.DocId;
      this.api.info(id).then(res => {
        if (res.Code === 0) {
          if (row.ProcessingType == "注塑") {
            if (row.StorageMethod == 0) {
              //按胶件入库
              console.log('editinjectionmolding1');
              this.toURL({ name: 'editinjectionmolding1', params: { type: 'edit', data: res.Data } });
            } else {
              //按模入库
              console.log('editinjectionmolding2');
              this.toURL({ name: 'editinjectionmolding2', params: { type: 'edit', data: res.Data } });
            }
          } else {
            console.log('editproductionshipping');
            this.toURL({ name: 'editproductionshipping', params: { type: 'edit', data: res.Data } })
          }
        }
      })
    },
    create() {
      this.toURL({
        name: 'editproductionshipping',
        params: { type: 'create' }
      })
    },
    create2() {
      this.toURL({
        name: 'editinjectionmolding',
        params: {
          type: 'create'
        }
      })
    },
    handleCommand(value) {
      if (value == 0) {
        //按胶件入库
        console.log('editinjectionmolding1');
        this.toURL({ name: 'editinjectionmolding1', params: { type: 'create' } });
      } else {
        //按模入库
        console.log('editinjectionmolding2');
        this.toURL({ name: 'editinjectionmolding2', params: { type: 'create' } });
      }
    },

     onPrint(row) {
      let newpage = this.$router.resolve({
        path: "/productionshippingPrint?id=" + row.DocId,
      });
      window.open(newpage.href, "_blank");
    },

    toURL(o) {
      this.$router.push(o)
    },
    /** 生成耗料单 */
    onGenerate() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要生成耗料单的数据");
        return;
      }
      this.$confirm("确认生成耗料单所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let Ids = rows.map((item) => item.DocId);
        this.api.examineUseDoc({ Ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("操作成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
          this.reload();
        }
      });
      }).catch(() => { });
    }
  }
};
</script>